import {useContext} from 'react';
import CartContext from '@mgp-fe/shared/modules/shop/state/CartContext.ts';

export default () => useContext(CartContext);